<template>
  <a-modal
    v-model:visible="visible"
    title="表盘功耗评级"
    :width="877"
    min-height
    wrap-class-name="modal-power-class"
  >
    <power-class-details
      class="pb-16"
      :watchface-power-data="watchfacePowerData"
      @close="close"
    />
    <template #footer>
      <a-button type="back" class="!mt-2.5" @click="close"> 关闭 </a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useWatchfacePowerClass } from '@/hooks';

const { resetWatchfacePowerData, watchfacePowerData } =
  useWatchfacePowerClass();

const visible = ref(false);
const open = async () => {
  visible.value = true;
  await resetWatchfacePowerData();
};
defineExpose({ open });

const close = () => {
  visible.value = false;
};
</script>
<style lang="less">
.modal-power-class {
  .ant-modal-content {
    .ant-modal-body {
      background-color: #0e0e0e;
    }
    .ant-modal-footer {
      height: 65px;
    }
  }
}
</style>
